/*
 * @Author: yongsheng.zhang 
 * @Date: 2017-10-18 11:04:58 
 * @Last Modified by:   yongsheng.zhang 
 * @Last Modified time: 2017-10-18 11:04:58 
 */
// pc首页轮播
const $ = require('jquery');

const sliderPicture = (selector, settings) => {
    // $(selector).each(function() {
    // });
    let $this = $(selector);
    let $link = $this.find('a');
    let width = $this.width();
    // let height = $this.height();
    let type = (settings.type || 'fade');
    // let arrows = settings.arrow;
    let auto = settings.autoplay;

    $this.addClass('jPicture-container').children().first().addClass('jPicture-inner').children().addClass('jPicture-part');

    // 图片区域禁用选择功能
    // 防止快速点击按钮或箭头时出现选中内容的问题
    // 设置初始图片索引为 0
    $this.on('selectstart', function() {
        return false;
    }).attr('data-cacheIndex', 0);

    let $inner = $this.find('.jPicture-inner');
    let $part = $this.find('.jPicture-part');
    // let $imglink = $this.find('img, a');
    let imgSize = $inner.find('img').length;

    // 给图片容器和其内部所有元素强制设置宽高
    // 建议传入的图片都能保证尺寸一致并且与最外层容器的大小相同
    // 以防因相关尺寸不统一而导致图片变形
    // $part.add($imglink).width(width).height(height);

    // 添加切换按钮
    let _pointDom = '<div class="nav-point-con"><ul class="nav-point">';
    let picItemArray = new Array(imgSize);
    // 循环生成图片DOM
    for (let index = 0; index < picItemArray.length; index++) {
        _pointDom += `<li class="point ${index === 0 ? 'active' : ''}" data-index="${index}"></li>`;
    }
    _pointDom = _pointDom + '</ul></div>';
    $(`${selector}`).append(_pointDom);
    // $inner.after(dot);
    // var $dot = $this.find('.jPicture-dot');
    // let $dot = $(this).find('.pic-nav-ul');
    let $point = $(selector).find('.point');
    // $dot.each(function() {
    //     $(this).css('marginLeft', -$(this).outerWidth(true) / 2 + 'px');
    // });
    // $point.first().addClass('active');

    // 添加左右切换箭头
    // isDeskTop && $this.append("<b class='jPicture-prev'></b><b class='jPicture-next'></b>");
    // let $prev = $this.find('.jPicture-prev'),
    // let $next = $this.find('.jPicture-next');

    // // 根据传入的参数判断是否显示按钮和箭头
    // if (typeof arrows === 'boolean' && !arrows) {
    //     $prev.add($next).hide();
    // }
    // 根据不同的图片切换效果进行不同的处理
    if (type === 'fade') {
        $inner.addClass('jPicture-fade');
        $part.first().show();
    }
    if (type === 'slide') {
        // let $part = $inner.find('.jPicture-part');
        let $part = $inner.find('.pic-item');
        let $partFirst = $part.first();
        let $partLast = $part.last();
        $inner.addClass('jPicture-slide').width(width * (imgSize + 2)).append($partFirst.clone(true)).prepend($partLast.clone(true)).css('left', -width + 'px');
    }

    // 设定统一的图片切换动画过渡时间为 700ms
    var time = 700;

    // 按钮切换和箭头切换
    $point.on('click', function() {
        var index = $(this).attr('data-index');
        Animation(index);
        $this.attr('data-cacheIndex', index);
    })
    // $prev.click(function() {
    //     var index = $this.data('cacheIndex');
    //     index--;
    //     Animation(index);
    // })
    // $next.click(function() {
    //     var index = $this.data('cacheIndex');
    //     index++
    //     Animation(index);
    // })
    // 动画寒素
    function Animation(i) {
        // if (type === 'fade') {
        //     i = (i === -1 ? imgSize - 1 : (i === imgSize ? 0 : i));
        //     $part.eq(i).stop().fadeIn(time).siblings().stop().fadeOut(time, function() {
        //         dotSwitch(i);
        //         $this.data('cacheIndex', i);
        //     });
        // }
        if (type === 'slide') {
            // 设置缓动效果
            $.easing.easeInOutQuart = function(x, t, b, c, d) {
                return ((t /= d / 2) < 1) ? c / 2 * t * t * t * t + b : -c / 2 * ((t -= 2) * t * t * t - 2) + b;
            }

            if (!$inner.is(':animated')) {
                dotSwitch(i);
                $inner.stop().animate({
                    left: -(width * i + width) + 'px'
                }, time, 'easeInOutQuart', function() {
                    // dotSwitch(i);
                    if (i === -1) {
                        $inner.css('left', '-' + width * imgSize + 'px');
                        i = imgSize - 1;
                    }
                    if (i === imgSize) {
                        $inner.css('left', '-' + width + 'px');
                        i = 0;
                    }
                    $this.attr('data-cacheIndex', i);
                    $link.removeClass('jPicture-pointerevents-none');
                });
            }
            // $inner.css('left', -(width * i + width) + 'px');
            // dotSwitch(i);
            // if (i === -1) {
            //     $inner.css('left', '-' + width * imgSize + 'px');
            //     i = imgSize - 1;
            // }
            // if (i === imgSize) {
            //     $inner.css('left', '-' + width + 'px');
            //     i = 0;
            // }
            // $this.attr('data-cacheIndex', i);
        }
    }

    // 按钮状态切换
    function dotSwitch(i) {
        if (i === imgSize) {
            $point.eq(0).addClass('active').siblings().removeClass('active');
        } else {
            $point.eq(i).addClass('active').siblings().removeClass('active');
        }
    }

    // 自动执行动画
    let getIndex;
    if (auto && typeof auto === 'number') {
        let autoAnimate = setInterval(function() {
            getIndex = $this.attr('data-cacheIndex')
            getIndex++
            Animation(getIndex)
        }, auto);
        $this.mouseenter(function() {
            clearInterval(autoAnimate);
        }).mouseleave(function() {
            autoAnimate = setInterval(function() {
                getIndex = $this.attr('data-cacheIndex');
                getIndex++;
                Animation(getIndex);
            }, auto);
        })
    }
}
module.exports = sliderPicture;



// WEBPACK FOOTER //
// ./src/lib/slider.js